<div class="ec-costs-container">
    <form [formGroup]="form" fxLayout="column">
        <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start">
            <div class="txt-h-16-7">
                {{ 'Split the value of expenses and provisions by type'|i18n }}
            </div>
            <div class="txt-s-16-4 ml-10">
                {{ 'Divide the total allocated for expenses into custom items (max. 5 items)'|i18n }}.
            </div>
            <div>
                <mat-checkbox app-checkbox formControlName="useCacv">
                    <span class="txt-p-14-4" [innerHTML]="'Use {0} in addition to TIP'|i18n: CACV_STRING"></span>
                </mat-checkbox>
            </div>
            <div [formGroup]="costForm" *ngFor="let costForm of costsControls; let i = index" fxLayout="row"
                 fxLayoutGap="20px" fxLayoutAlign="center center" class="w-100">
                <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start start" class="cost-container">
                    <span class="txt-p-14-4">{{ 'Expense item name'|i18n }}</span>
                    <div app-input-container class="w-60">
                        <input type="text" app-input formControlName="costName">
                        <div *ngIf="isControlOK(costForm, 'costName')" app-error>
                            {{ 'Invalid name'|i18n }}
                        </div>
                    </div>
                    <mat-radio-group formControlName="costType"
                                     fxLayout="column"
                                     fxLayoutGap="25px"
                                     color="primary"
                                     fxFlex class="mt-20 ml-20">
                        <mat-radio-button
                                [ngClass]="isNotSelected(costForm, ECCostType.SHARED_ENERGY) ? 'disabled-text' : ''"
                                app-radio-button class="txt-p-16-4" [value]="ECCostType.SHARED_ENERGY" fxFlex="60">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <span>{{ 'Cost'|i18n }} €</span>
                                <div app-input-container class="w-15">
                                    <input type="number"
                                           step="0.01"
                                           app-input
                                           formControlName="costSharedEnergy"
                                           (input)="limitDecimals(costForm, 'costSharedEnergy')"
                                           [attr.disabled]="isNotSelected(costForm, ECCostType.SHARED_ENERGY) ? '' : null">
                                    <div *ngIf="isControlOK(costForm, 'costSharedEnergy')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <span>{{ '/ MWh ' + ('of shared energy'|i18n) + ' = ' }}</span>
                                <span class="text-bold">{{ computedSharedEnergy(costForm)?.value|niceValue: '€': 2 }}</span>
                            </div>
                        </mat-radio-button>

                        <mat-radio-button [ngClass]="isNotSelected(costForm, ECCostType.POD) ? 'disabled-text' : ''"
                                          app-radio-button class="txt-p-16-4" [value]="ECCostType.POD" fxFlex="60">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <span>{{ 'Fixed cost of'|i18n }} €</span>
                                <div app-input-container class="w-15">
                                    <input type="number"
                                           step="0.01"
                                           app-input
                                           formControlName="costPod"
                                           (input)="limitDecimals(costForm, 'costPod')"
                                           [attr.disabled]="isNotSelected(costForm, ECCostType.POD) ? '' : null">
                                    <div *ngIf="isControlOK(costForm, 'costPod')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <span>{{ ('for POD'|i18n) + ' = ' }}</span>
                                <span class="text-bold">{{ computedPod(costForm)?.value|niceValue: '€': 2 }}</span>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [ngClass]="isNotSelected(costForm, ECCostType.POD) ? 'disabled-text' : ''"
                                          [title]="'This amount is calculated on annual period.'|i18n">
                                </app-icon>
                            </div>
                        </mat-radio-button>

                        <mat-radio-button
                                [ngClass]="isNotSelected(costForm, ECCostType.PERCENTAGE) ? 'disabled-text' : ''"
                                app-radio-button class="txt-p-16-4" [value]="ECCostType.PERCENTAGE" fxFlex="60">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <span>{{ 'Percentage of expense'|i18n }}:</span>
                                <div app-input-container class="w-15">
                                    <input type="number"
                                           step="0.01"
                                           app-input
                                           formControlName="costPercentage"
                                           (input)="limitDecimals(costForm, 'costPercentage')"
                                           [attr.disabled]="isNotSelected(costForm, ECCostType.PERCENTAGE) ? '' : null">
                                    <div *ngIf="isControlOK(costForm, 'costPercentage')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <span>{{ '% ' + ('of'|i18n) + ' ' + (getTipValue|niceValue:'': 2) + ' = ' }}</span>
                                <span class="text-bold">{{ computedPercentage(costForm)?.value|niceValue: '€': 2 }}</span>
                            </div>
                        </mat-radio-button>
                        <mat-radio-button [ngClass]="isNotSelected(costForm, ECCostType.FIXED) ? 'disabled-text' : ''"
                                          app-radio-button
                                          class="txt-p-16-4" [value]="ECCostType.FIXED" fxFlex="60">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                <span>{{ 'Fixed cost of'|i18n }} €</span>
                                <div app-input-container class="w-15">
                                    <input type="number"
                                           step="0.01"
                                           app-input
                                           formControlName="costFixed"
                                           (input)="limitDecimals(costForm, 'costFixed')"
                                           [attr.disabled]="isNotSelected(costForm, ECCostType.FIXED) ? '' : null">
                                    <div *ngIf="isControlOK(costForm, 'costFixed')" app-error>
                                        {{ 'Invalid value'|i18n }}
                                    </div>
                                </div>
                                <span>{{ 'for the community'|i18n }}</span>
                                <span class="text-bold">{{ computedFixed(costForm)?.value|niceValue: '€': 2 }}</span>
                                <app-icon icon-color-h name="fas-info-circle"
                                          [ngClass]="isNotSelected(costForm, ECCostType.FIXED) ? 'disabled-text' : ''"
                                          [title]="'This amount is calculated on annual period.'|i18n">
                                </app-icon>
                            </div>
                        </mat-radio-button>
                        <mat-radio-button
                                [ngClass]="isNotSelected(costForm, ECCostType.PERCENTAGE_LOWERBOUND)? 'disabled-text' : ''"
                                app-radio-button
                                radio-button-start-align
                                class="txt-p-16-4"
                                [value]="ECCostType.PERCENTAGE_LOWERBOUND"
                                fxFlex="60"
                                >
                            <div fxLayoutGap="10px" fxLayout="column">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <span>{{ 'Percentage of expense'|i18n }}:</span>
                                    <div app-input-container class="w-15">
                                        <input type="number"
                                               step="0.01"
                                               app-input
                                               formControlName="costPercentageLowerbound"
                                               (input)="limitDecimals(costForm, 'costPercentageLowerbound')"
                                               [attr.disabled]="isNotSelected(costForm, ECCostType.PERCENTAGE_LOWERBOUND) ? '' : null">
                                        <div *ngIf="isControlOK(costForm, 'costPercentageLowerbound')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                    <span>{{ '% ' + ('of'|i18n) + ' ' + (getTipValue|niceValue:'': 2) + ' = ' }}</span>
                                    <span class="text-bold">{{ computedPercentageLowerbound(costForm)?.value|niceValue: '€': 2 }}</span>
                                    <app-icon icon-color-h name="fas-info-circle"
                                              [ngClass]="isNotSelected(costForm, ECCostType.PERCENTAGE_LOWERBOUND) ? 'disabled-text' : ''"
                                              [title]="'It\'s also possible to define a fixed amount per year'|i18n">
                                    </app-icon>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <span>({{ 'minimum of €'|i18n }}:</span>
                                    <div app-input-container class="w-15">
                                        <input type="number"
                                               step="0.01"
                                               app-input
                                               formControlName="lowerBound"
                                               (input)="limitDecimals(costForm, 'lowerBound')"
                                               [attr.disabled]="isNotSelected(costForm, ECCostType.PERCENTAGE_LOWERBOUND) ? '' : null">
                                        <div *ngIf="isControlOK(costForm, 'lowerBound')" app-error>
                                            {{ 'Invalid value'|i18n }}
                                        </div>
                                    </div>
                                    <span>{{ ' )'|i18n }}:</span>
                                </div>
                            </div>
                        </mat-radio-button>
                    </mat-radio-group>

                </div>
                <button app-icon-button class="app-button-alert pull-right"
                        [title]="'Remove cost'|i18n"
                        (click)="onClickRemoveCost(i)">
                    <app-icon name="fal-trash-alt"></app-icon>
                </button>
            </div>

            <div class="w-100" fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="center center">
                <button app-ghost-button (click)="addCostForm(EMPTY_COST)" [disabled]="costsFormArray.length >= 5">
                    <app-icon name="fal-plus-square"></app-icon>
                    {{ 'Add expense item'|i18n }}
                </button>
                <span app-error *ngIf="costsFormArray.length >= 5">
                    {{ 'You have reached the limit of available income'|i18n }}.
                </span>

                <div fxLayout="column" fxLayoutGap="15px" class="mt-10">
                    <div fxLayout="row" fxLayoutGap="5px">
                        <span class="txt-h-16-7">
                            {{ 'Total remaining revenue'|i18n }}:
                        </span>
                        <span class="txt-h-16-4">
                            {{ (computeTotal(true) - computeTotalCosts) |niceValue: '€': 2: computeTotalCosts > computeTotal(true) }}
                        </span>
                    </div>
                    <div fxLayout="row" fxLayoutGap="5px">
                        <span class="txt-h-16-7">
                            {{ 'Total configured costs'|i18n }}:
                        </span>
                        <span class="txt-h-16-4">
                            {{ computeTotalCosts|niceValue: '€':2 }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
